//Gift voucher = a single-use 100%-off code sold on Etsy. The client receives a link like
//  https://loveinbook.../?voucher=12345678
//We grab that code the moment the app loads, stash it, and scrub it from the address bar so a
//refresh or a shared URL stays clean. The checkout then validates it and, if good, offers a free
//digital book. This is the CLIENT half of the flow; the server (addDigitalOrder) is the source of
//truth that actually consumes the code and marks the order paid.

const KEY = 'giftVoucher'

//Read ?voucher= from the current URL, persist it, and strip it out. Must run BEFORE React renders
//(the order store reads localStorage in its useState initializer, which happens during render,
//before any effect) — so it's called at App module load, not in an effect.
export function captureGiftVoucher() {
    try {
        const params = new URLSearchParams(window.location.search)
        const code = (params.get('voucher') || '').trim()
        if (!code) return
        localStorage.setItem(KEY, code)
        params.delete('voucher')
        const qs = params.toString()
        const clean = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash
        window.history.replaceState({}, '', clean)
    } catch (_) {}
}

export function getStoredGiftVoucher() {
    try { return localStorage.getItem(KEY) || '' } catch (_) { return '' }
}

export function clearStoredGiftVoucher() {
    try { localStorage.removeItem(KEY) } catch (_) {}
}
